import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import PcPosition from '@/views/position-list/position-list-pc.vue'
import h5MyPosition from '@/views/my-management/h5-my-position.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (!_ctx.$isMobile)
    ? (_openBlock(), _createBlock(PcPosition, {
        key: 0,
        type: "myApply"
      }))
    : (_openBlock(), _createBlock(h5MyPosition, {
        key: 1,
        type: "myApply"
      }))
}
}

})